import { apiFetch } from './api';

/**
 * Get dashboard statistics
 */
export function getDashboardStats() {
  return apiFetch('/api/admin/dashboard/stats');
}

/**
 * Get dashboard chart data
 * @param {string} period - 'today', 'week', 'month', 'year'
 */
export function getDashboardCharts(period = 'year') {
  return apiFetch(`/api/admin/dashboard/charts?period=${period}`);
}

/**
 * Get recent license requests
 * @param {number} limit - Number of recent licences to fetch
 */
export function getRecentLicences(limit = 10) {
  return apiFetch(`/api/admin/dashboard/recent-licences?limit=${limit}`);
}

/**
 * Get quotation status breakdown
 */
export function getQuotationStatus() {
  return apiFetch('/api/admin/dashboard/quotation-status');
}

/**
 * Get translation distribution data
 */
export function getTranslations() {
  return apiFetch('/api/admin/dashboard/translations');
}

/**
 * Get unread messages for dashboard
 * @param {number} limit - Maximum number of messages to return
 */
export function getUnreadMessages(limit = 5) {
  return apiFetch(`/api/admin/dashboard/unread-messages?limit=${limit}`);
}

